import React, { useState, useEffect } from "react";
import PageNotFound from "../education-components/PageNotFound";
import SearchNav from "@/education-components/SearchSchool/SearchNavBar/SearchNav";
import LoadingSpinner from "../components/LoadingSpinner";
import useHeaderFooter from "@/hooks/useHeaderFooter";
import { applicationLabelFetchData, fetchData2 } from "../service/api";
import { useDispatch } from "react-redux";
import { fetchDataSuccess,setParentPageNotFound } from "../redux/dataSlice";
import { PAGE_NOT_FOUND,PARENT_404PAGE } from "@/utils/constants";
import { useRouter } from "next/router";
import ParentPageNotFound from "@/parent-components/ParentPageNotFound";
import CommonLayout from "@/parent-components/CommonLayout";
import { fetchParentData } from "../parentService/parentApi";

const Page404 = () => {
  const [data, setData] = useState(null);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const router = useRouter();

  const { asPath } = router;

  useHeaderFooter();

  useEffect(() => {
    const fetchDatas = async () => {
      try {
        if(asPath.includes('/parent/')) {
  
          const result = await fetchParentData(PARENT_404PAGE);
          if (result?.data) {
            setData(result);
            dispatch(setParentPageNotFound(result?.data));
          }
        } else {
          const result = await fetchData2(PAGE_NOT_FOUND);

        if (result?.data?.data) {
          setData(result);
          dispatch(fetchDataSuccess(result?.data?.data));
        }
        }
      } catch (err) {
        setError(err);
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDatas();
  }, [dispatch]);

 

  const pageTitle = data?.data?.aeppagenotfound?.contentarticle?.results?.[0]?.title ?? "Whoops! This Page Escaped Us";
  
  if (loading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  if (error || !data?.data) {
    return <div>{"No data"}</div>;
  }

  // dispatch(fetchDataSuccess(data?.data?.data));
  const PageNotFound_Details = data?.data?.data;
  dispatch(fetchDataSuccess(PageNotFound_Details));

  const render404Page = (path: string) => {
    if (path.includes('/parent/')) {
      return (
        <CommonLayout additionalProp={pageTitle}>
          <ParentPageNotFound />
        </CommonLayout>
      );
    }
    
    return (
      <>
        <div className="container">
          <SearchNav />
        </div>
        <PageNotFound />
      </>
    );
  };
  

  return (
    <>
      {render404Page(asPath)}
    </>
  );
};

export default Page404;
